export default import.meta.ROLLDOWN_FILE_URL_ezDZN6xDnSNL7vcEPPpLtA